import { styled } from '@mui/material/styles';
import { DialogContent, IconButton } from '@mui/material';

interface PaperProps {
  $backgroundColor?: string;
  $width?: string;
  $padding?: string;
  $rounded?: string;
  $overflowY?: 'auto' | 'visible';
}

export const Paper = styled('div')<PaperProps>(({ $backgroundColor, $width, $padding, $rounded, $overflowY }) => ({
  backgroundColor: $backgroundColor ?? 'var(--white)',
  border: 'none',
  borderRadius: $rounded ? $rounded : 0,
  boxShadow: 'none',
  overflowY: $overflowY || 'auto',
  padding: $padding ? $padding : '30px',
  ...($width && { maxWidth: $width, width: '100%' }),
}));

export const Close = styled(IconButton)({
  position: 'absolute',
  top: 10,
  right: 10,
  color: '#1A1538',
  zIndex: 2,
});

export const Title = styled('div')({
  marginBottom: '24px',
  display: 'flex',
  color: '#1A1538',
  fontSize: '24px',
  textAlign: 'left',
});

export const DialogText = styled(DialogContent)({
  display: 'flex',
  justifyContent: 'flex-start',
  textAlign: 'left',
  flexDirection: 'column',
});

export const DialogTitle = styled('div')({
  paddingTop: 24,
});

export const Blur = styled('div')({
  background: 'rgba(26, 21, 56, 0.6)',
});
